import React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { usePlanFeatures } from "../../hooks/usePlanFeatures"
import { featureForPath } from "../../constants/featureRoutes"

const NAVY = "#221C5D"
const ORANGE = "#E56A22"
const RED = "#dc3545"

const formatDate = (value) => {
  if (!value) return ""
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? "" : date.toLocaleDateString("tr-TR")
}

/**
 * Deneme süresiyle açılmış bir özelliğin sayfasında, en üstte kalan gün sayacı.
 *
 * Kullanıcı özelliği paketinde sanmasın diye: erişim geçicidir ve süre dolduğunda
 * sayfa yeniden kapanır. Son gün kırmızıya döner.
 *
 * Sayfa başına eklenmez — Layout'ta bir kez durur ve hangi özelliğin sayfasında
 * olunduğunu rotadan çözer (bkz. constants/featureRoutes.js). Aktif deneme yoksa
 * hiçbir şey çizmez.
 *
 * Konumlandırma custom.css'teki `.feature-trial-banner` kuralındadır: fixed topbar
 * main-content'in ilk çocuğunu örttüğü için şerit header yüksekliği kadar itilir ve
 * scroll'da görünür kalsın diye header'ın altına yapışır.
 */
const FeatureTrialBanner = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { trialFor } = usePlanFeatures()

  const feature = featureForPath(location.pathname)
  const trial = feature ? trialFor(feature) : null

  if (!trial?.active) return null

  const lastDay = (trial.remainingDays ?? 0) <= 1
  const accent = lastDay ? RED : ORANGE

  return (
    <div
      className="feature-trial-banner d-flex flex-wrap align-items-center justify-content-between gap-2 px-3 py-2"
      style={{
        background: `${accent}1a`,
        borderBottom: `1px solid ${accent}55`,
        fontSize: ".82rem",
      }}
    >
      <div className="d-flex align-items-center" style={{ gap: ".5rem", color: "#4b5563" }}>
        <i className="bx bx-time-five" style={{ fontSize: "1.1rem", color: accent }} />
        <span>
          <strong>{trial.label}</strong> özelliğini ücretsiz deniyorsunuz —{" "}
          <strong style={{ color: accent }}>
            {trial.remainingDays} gün kaldı
          </strong>
          {trial.endsAt && (
            <span style={{ color: "#94a3b8" }}> ({formatDate(trial.endsAt)} tarihinde sona erer)</span>
          )}
        </span>
      </div>

      <button
        className="btn btn-sm"
        style={{ backgroundColor: NAVY, borderColor: NAVY, color: "#fff", borderRadius: 999, fontWeight: 600 }}
        onClick={() => navigate("/subscription/plans")}
      >
        <i className="bx bx-up-arrow-circle me-1" />
        Paketimi Yükselt
      </button>
    </div>
  )
}

export default FeatureTrialBanner
